import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function Breadcrumbs({ items }) {
  // items: [{ name, path }]
  return (
    <nav aria-label="Breadcrumb" className="text-[11px] tracking-[0.22em] uppercase text-[#7a7369]">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.path} className="flex items-center gap-2">
              {i > 0 && <ChevronRight size={12} strokeWidth={1.5} className="text-[#B5876C]" />}
              {last ? (
                <span className="text-[#2E2C28]" aria-current="page">{it.name}</span>
              ) : (
                <Link to={it.path} className="hover:text-[#B5876C] transition-colors">{it.name}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
